import { observable } from 'mobx';
import { FormikHelpers } from 'formik';

import {
  API_ACCOUNT_WITHDRAW_SAVE_RESERVE,
  API_ACCOUNT_WITHDRAW_RESERVE,
  API_ACCOUNT_TRANSFER_SAVE_RESERVE,
  API_ACCOUNT_TRANSFER_RESERVE,
  API_ACCOUNT_DETAIL_RESERVES,
  API_ACCOUNT_DETAIL_SAVE_RESERVE,
  API_ACCOUNT_DETAIL_RESERVE,
  API_ACCOUNT_FINANCE_SAVE_RESERVE,
  API_ACCOUNT_FINANCE_RESERVE,
  API_ACCOUNT_FINANCE_RESERVES,
  API_FUNCTION_TYPE,
  API_FUNCTION_TYPE_TARGET,
} from 'api/endpoints';

import { FormStore } from 'stores/formStore';
import { RootStore } from 'stores/rootStore';
import { Reserve, ReservesData } from './model';
import { ViewMode } from 'pages/Accounts/Edit/components/viewModes';

export class ReservesStore extends FormStore<Reserve> {
  accountId: string;
  prefixDepth: number;
  endpointReserves: API_FUNCTION_TYPE;
  endpointReserve: API_FUNCTION_TYPE_TARGET;
  endpointSaveReserve: API_FUNCTION_TYPE;

  @observable allReserves?: ReservesData;

  constructor(rootStore: RootStore, accountId: string, viewMode?: ViewMode) {
    super(rootStore);
    this.accountId = accountId;
    this.allReserves = undefined;

    switch (viewMode) {
      case ViewMode.DETAIL:
        this.endpointReserves = API_ACCOUNT_DETAIL_RESERVES;
        this.endpointReserve = API_ACCOUNT_DETAIL_RESERVE;
        this.endpointSaveReserve = API_ACCOUNT_DETAIL_SAVE_RESERVE;
        this.prefixDepth = 1;
        break;
      case ViewMode.WITHDRAW:
        this.endpointReserves = API_ACCOUNT_FINANCE_RESERVES; // not used in withdrawal
        this.endpointReserve = API_ACCOUNT_WITHDRAW_RESERVE;
        this.endpointSaveReserve = API_ACCOUNT_WITHDRAW_SAVE_RESERVE;
        this.prefixDepth = 1;
        break;
      case ViewMode.TRANSFER:
        this.endpointReserves = API_ACCOUNT_FINANCE_RESERVES; // not used in trasnfer
        this.endpointReserve = API_ACCOUNT_TRANSFER_RESERVE;
        this.endpointSaveReserve = API_ACCOUNT_TRANSFER_SAVE_RESERVE;
        this.prefixDepth = 1;
        break;
      default:
        this.endpointReserves = API_ACCOUNT_FINANCE_RESERVES;
        this.endpointReserve = API_ACCOUNT_FINANCE_RESERVE;
        this.endpointSaveReserve = API_ACCOUNT_FINANCE_SAVE_RESERVE;
        this.prefixDepth = 1;
        break;
    }
  }

  fetchAllReserves = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.rootStore.stores.apiStore.get<ReservesData>(this.endpointReserves(this.accountId));
    if (response?.data) {
      this.allReserves = response.data;
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };

  fetchReserve = async (reserveId: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.fetchData(this.endpointReserve(this.accountId, reserveId));
    this.rootStore.stores.uiStore.setLoading(false);
  };

  deleteReserve = async (reserveId: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.rootStore.stores.apiStore.delete(this.endpointReserve(this.accountId, reserveId));
    this.rootStore.stores.uiStore.setLoading(false);
  };

  handleSubmit = async (values: Reserve, formikHelpers: FormikHelpers<Reserve>) => {
    return await this.submitData(this.endpointSaveReserve(this.accountId), values, {
      formikHelpers,
      reset: false,
      validationPrefixDepth: this.prefixDepth,
      singleValueResponse: true,
    });
  };
}
